import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { uniqueIdentificationGenerator } from '../../utils/uniqueIdentificationGenerator'

import warningIcon from 'images/warning-icon.svg'
import errorIcon from 'images/error-icon.svg'
import successIcon from 'images/success-icon.svg'
import eyeStrokeIcon from 'images/eye-stroke.svg'
import eyeIcon from 'images/eye.svg'

class PasswordInput extends Component {
  static propTypes = {
    /* The input placeholder */
    placeholder: PropTypes.string,

    /* The text that will be displayed along with the input */
    label: PropTypes.string,

    /* The input name */
    name: PropTypes.string,

    /* The input id */
    id: PropTypes.string,

    /* The text that will be displayed below the input */
    helpText: PropTypes.string,

    /* The text that will be displayed below the input when the input is valid */
    successText: PropTypes.string,

    /* The text that will be displayed below the input when an error is found */
    errorText: PropTypes.string,

    /* The text that will be displayed below the input when an warning need to be displayed */
    warningText: PropTypes.string,

    /* The element classes */
    className: PropTypes.string,

    /* Initial value */
    value: PropTypes.string,

    /* Callback for when the input changes */
    onChange: PropTypes.func,

    /* Determine if the input is or not required */
    required: PropTypes.bool,

    /* Determine if the input is or not disabled */
    disabled: PropTypes.bool,

    /* Determine if the input is or not readonly */
    readOnly: PropTypes.bool,

    /* Function that will be triggered when the value changes. May return true or false to wheter the new value is or not valid */
    validateValue: PropTypes.func,

    /* Define the max lenght of input, default 50 */
    maxLength: PropTypes.number,
  }

  state = {
    /* The input value  */
    value: this.props.value || '',

    /* Stores the information of wheter the input is or not valid  */
    isValid: null,

    /* Stores the information of wheter the password is or not shown */
    showPassword: false,

    maxLength: 50,
  }

  getClasses() {
    const { disabled, readOnly } = this.props
    const { isValid } = this.state
    return `
            ${disabled ? 'disabled' : ''}
            ${isValid === false ? 'invalid' : ''}
            ${isValid === true ? 'valid' : ''}
            ${readOnly ? 'read-only' : ''}
        `
  }

  onChange(e) {
    const { onChange = () => {} } = this.props
    onChange(e)
    this.setState({
      value: e.target.value,
      isValid: this.valueIsValid(e.target.value),
    })
  }

  valueIsValid(value) {
    const { required, validateValue } = this.props

    if (validateValue) {
      return validateValue(value)
    }
    return required && value === ''
  }

  textHelperDisplay() {
    const { errorText, warningText, helpText, successText } = this.props
    const { isValid } = this.state

    if (isValid === true) {
      if (successText)
        return ['success', <img key='successIcon' src={successIcon} />, successText]
    } else if (isValid !== false) {
      if (helpText) return ['default', null, helpText]
    } else {
      if (errorText) {
        return ['error', <img key='errorIcon' src={errorIcon} />, errorText]
      }
      if (warningText) {
        return ['warning', <img key='warningIcon' src={warningIcon} />, warningText]
      }
    }
    return ['', null, null]
  }

  render() {
    const {
      label,
      name,
      required,
      disabled,
      className,
      id,
      placeholder,
      maxLength,
    } = this.props
    const { value, showPassword } = this.state

    const customId = id || uniqueIdentificationGenerator('input-text_')
    const customName = name || uniqueIdentificationGenerator('input-text_')
    const classes = this.getClasses()
    const [inputValidationClass, inputSmallIcon, inputSmallText] =
      this.textHelperDisplay()

    return (
      <>
        <div
          className={`input-password-container ${inputValidationClass} ${classes}`}
        >
          <label>{label}</label>
          <div className='password-input-group'>
            <input
              type={showPassword ? 'text' : 'password'}
              id={customId}
              name={customName}
              disabled={disabled}
              required={required}
              className={className || 'form-control-password'}
              onChange={(e) => this.onChange(e)}
              value={value}
              placeholder={placeholder}
              maxLength={maxLength}
            />
            {value && (
              <span>
                {showPassword ? (
                  <img
                    className='dark-eye-icon'
                    src={eyeIcon}
                    onClick={() => this.setState({ showPassword: false })}
                  />
                ) : (
                  <img
                    className='light-eye-icon'
                    src={eyeStrokeIcon}
                    onClick={() => this.setState({ showPassword: true })}
                  />
                )}
              </span>
            )}
          </div>
          {inputSmallText && (
            <small className={inputValidationClass}>
              {inputSmallIcon}
              {inputSmallText}
            </small>
          )}
        </div>
      </>
    )
  }
}

export default PasswordInput
